import { ComboBox, Dropdown, IComboBox, IComboBoxOption, IComboBoxStyles, IDropdownOption, Label, Spinner, TextField, VirtualizedComboBox } from "@fluentui/react";
import { FormEvent, useEffect, useId, useState } from "react";


interface IComboBoxComponent {
  text: string;
  required?: boolean;
  data: IComboBoxOption[];
  disable?: boolean;
  placeholder?: string;
  width?: string;
  loading?: boolean;
  onChange?: (value: string) => void;
  onOptionSelect?: (
    event: FormEvent<IComboBox>, option?: IComboBoxOption | undefined
  ) => void;
  defaultSelectedOptions?: IComboBoxOption[];
  selectedKey?: string | number | string[] | number[] | null;
  value?: string;
  multiSelect?:boolean
}

interface ISelectedOptions {
  text: string;
  key: string | number;
}

export const ComboBoxComponent = (props: IComboBoxComponent) => {
  const [value, setValue] = useState<string>(props.selectedKey ? props.selectedKey.toString() : "");
  const [dataSeleccionada, setDataSeleccionada] = useState<ISelectedOptions[]>([]);

  useEffect(() => {
    if (props.defaultSelectedOptions && props.defaultSelectedOptions.length > 0) {
      setDataSeleccionada(props.defaultSelectedOptions);
      setValue(props.defaultSelectedOptions[0]?.text || "");
    } else {
      setDataSeleccionada([]);
    }
  }, [props.defaultSelectedOptions]);

  const handleInputChange = (text: string) => {
    setValue(text);
    if (props.onChange) props.onChange(text);
  };

  useEffect(() => {
    if (dataSeleccionada.length > 0) {
      const dat = dataSeleccionada.map(x => x.text).join(", ");
      setValue(dat);
    }
  }, [dataSeleccionada]);

  const onSelect = (event: FormEvent<IComboBox>, option?: IComboBoxOption | undefined) => {
    if (option) {
      const opcion: ISelectedOptions = {
        text: option.text,
        key: option.key,
      };
      setDataSeleccionada([opcion]);
      setValue(opcion.text);
      if (props.onOptionSelect) props.onOptionSelect(event, opcion);
    }
  };

  const comboBoxStyles: Partial<IComboBoxStyles> = {
    root: {
      width: '100%'
    },
    callout: {
      minWidth: "275px", 
      width: "275px",
      maxHeight: props.data && props.data.length >= 10 ? 50 : undefined,
      overflowY: 'auto'
    },
    optionsContainer: {
      minWidth: "275px", 
    },

  };

  return (
    <div
      style={{
        width: props.width == null ? "100%" : props.width,
        minWidth: "100px",
        marginTop: "20px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <VirtualizedComboBox
        options={props.data}
        defaultValue={props.value}
        label={props.text}
        selectedKey={props.selectedKey || dataSeleccionada[0]?.key}
        disabled={props.disable || false}
        allowFreeform
        onChange={onSelect}
        onInputValueChange={handleInputChange}
        autoComplete="on"
        styles={comboBoxStyles}
        placeholder={props.placeholder}
        errorMessage={props.required && !value ? `El campo ${props.text} es requerido.` : undefined}
      />
    </div>
  );
};
